"use client";

import * as React from "react";
import { cn } from "../../lib/utils";

// Decorative star/sparkle icon
const StarIcon = () => (
  <svg
    width="41"
    height="39"
    viewBox="0 0 41 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1313 41.5286C21.256 30.5392 29.6909 21.8633 40.3751 20.8222C29.6909 19.6654 21.256 10.9895 20.1313 0C19.1191 10.9895 10.5717 19.6654 0 20.7065C10.6842 21.8633 19.1191 30.5392 20.1313 41.5286Z"
      fill="#FFB04A"
    />
  </svg>
);

export interface ReferralCardProps {
  className?: string;
  title: string;
  description: React.ReactNode;
  buttonText: string;
  onButtonClick?: () => void;
}

function ReferralCard({
  className,
  title,
  description,
  buttonText,
  onButtonClick,
}: ReferralCardProps) {
  return (
    <div
      className={cn(
        "relative w-full rounded-lg border border-black bg-[#FFBE6B] p-3 overflow-hidden shadow-[0px_4px_0px_0px_#000000]",
        "flex items-end justify-between",
        className
      )}
    >
      {/* Decorative Star Icons */}
      <div className="absolute -top-2 right-4">
        <StarIcon />
      </div>
      <div className="absolute -bottom-2 left-[139px]">
        <StarIcon />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col gap-1.5 h-[80px]">
        <h3 className="text-[#344054] text-base font-semibold font-plus-jakarta-sans leading-normal">
          {title}
        </h3>
        <p className="text-[#475467] text-sm font-normal font-plus-jakarta-sans leading-normal w-[216px]">
          {description}
        </p>
      </div>

      {/* Button */}
      <button
        type="button"
        onClick={onButtonClick}
        className="relative z-10 cursor-pointer bg-white border border-black rounded-lg px-3 py-2 flex items-center gap-1.5 hover:bg-gray-50 transition-colors shrink-0"
      >
        <span className="text-[#0D41E1] text-sm font-medium">{buttonText}</span>
      </button>
    </div>
  );
}

export { ReferralCard };
